import { render } from "./WeChat.vue?vue&type=template&id=3c870ae4&scoped=true"
import script from "./WeChat.vue?vue&type=script&lang=js"
export * from "./WeChat.vue?vue&type=script&lang=js"

import "./WeChat.vue?vue&type=style&index=0&id=3c870ae4&scoped=true&lang=css"

import exportComponent from "/Users/huangzexu/Code/Vue/Yiban/yiban/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c870ae4"]])

export default __exports__